import './styledTable.css';
export const StyledCell = ({className, style, children, onClick}) => <td className='td-class' onClick={onClick} style={style}>{children}</td>;

export const StyledRow = ({className, selectable, style, children,valign,  ...rest}) => <th valign={valign} className={`th-class ${selectable && 'th-class-selectable'}`} style={style} {...rest}>{children}</th>;

export const StyledBody = ({className, style, children}) => <tbody className="tbody-class" style={style}>{children}</tbody>;

export const StyledHead = ({className, style, children, id, valign}) => <thead valign={valign} id={id} className={`thead-class ${className}`} style={style}>{children}</thead>;

export const StyledTable = ({className, style, children, id}) => <table id={id} className="table-class" style={style}>{children}</table>;